const translations = {
  "en": {
    "Related News": "Related News",
    "View More": "View More"
  },
  "zh-tw": {
    "Related News": "相關新聞",
    "View More": "查看更多"
  }
};

export default translations;
